import { Box, Button, Grid, Typography } from '@mui/material';
import { getEventTicketUrl } from './WidgetConfig';

const TodayExperience = ({ events, date }) => {
  const today = new Date().toISOString().split('T')[0];

  // Filter events happening today
  const todayEvents = events.filter((event) => {
    const eventDate = new Date(`${event.EventDate}T00:00:00`);
    const selectedDate = new Date(`${date}T00:00:00`);

    return eventDate >= selectedDate;
  });
  return (
    <>
      <Grid item lg={12} md={12} sm={12} xs={12}>
        <Box>
          {todayEvents.map((event, index) => {
            const eventTicketUrl = getEventTicketUrl(event);
            return (
              <Box
                key={index}
                sx={{
                  mt: 2,
                  border: '1px solid #f1f1f1',
                  borderRadius: '14px',
                  p: 1.2,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1.5,
                }}
              >
                <Box
                  sx={{
                    width: 72,
                    height: 72,
                    borderRadius: '12px',
                    background: `url('${event?.EventImage || coverImage}')`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    flexShrink: 0,
                  }}
                />
                <Box sx={{ minWidth: 0 }}>
                  <Typography
                    sx={{
                      fontWeight: 800,
                      fontSize: '13px',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                    }}
                  >
                    {event?.EventName || event?.name}
                  </Typography>
                  <Typography
                    sx={{
                      color: '#777',
                      fontSize: '11px',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                    }}
                  >
                    {event?.Description || 'Experience something special'}
                  </Typography>
                  <a
                    href={eventTicketUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Typography
                      sx={{
                        mt: 1,
                        display: 'inline-flex',
                        bgcolor: 'primary.main',
                        color: '#fff',
                        borderRadius: '8px',
                        px: 1.5,
                        py: 0.7,
                        fontWeight: 800,
                        fontSize: '11px',
                      }}
                    >
                      Book Now
                    </Typography>
                  </a>
                </Box>
              </Box>
            );
          })}
        </Box>
      </Grid>
    </>
  );
};

export default TodayExperience;
